import { render, staticRenderFns } from "./ProductEditCard.vue?vue&type=template&id=28101359&scoped=true"
import script from "./ProductEditCard.vue?vue&type=script&lang=ts"
export * from "./ProductEditCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditCard.vue?vue&type=style&index=0&id=28101359&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28101359",
  null
  
)

export default component.exports